import { IAnalyticSdr } from '../../../types/analyticsSdr';

const siteSection = 'Settings';

export const profileAnalytics: IAnalyticSdr = {
  profile: {
    siteSection,
    siteSubSection: 'Profile',
  },
};
